//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IHttpService, IPromise } from 'angular';
import { IPromiseService } from 'pinsights-js-shared';

export interface ICheckUrlResponse {
  valid: boolean;
  reason?: string;
}

export default class CheckUrlService {
  constructor(
    private readonly $http: IHttpService,
    private readonly PromiseService: IPromiseService,
  ) {}

  public checkUrl(url: string): IPromise<ICheckUrlResponse> {
    return this.PromiseService.processHttpResponse(
      this.$http.post('/api/validation/check-url', { url }),
    );
  }
}

const curalate = angular.module('curalate');

curalate.service('CheckUrlService', [
  '$http',
  'PromiseService',
  CheckUrlService,
]);
